import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=413b5c26&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('413b5c26')) {
      api.createRecord('413b5c26', component.options)
    } else {
      api.reload('413b5c26', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=413b5c26&", function () {
      api.rerender('413b5c26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2faQRRYQ0518e/JS/comp/ImgFallback.vue"
export default component.exports